export function BackgroundPattern() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Top center - Soft lavender gradient matching the design */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[960px] h-[380px]"
        style={{
          background:
            'radial-gradient(ellipse 90% 80% at 50% 0%, rgba(188, 166, 255, 0.28) 0%, rgba(220, 205, 255, 0.12) 45%, transparent 72%)',
        }}
      />
    </div>
  );
}
